<template>
    <div>
        <v-container mt-5>
            <v-card
                max-width="500"
                min-height="200"
                class="mx-auto"
            >
             <v-card-text>
<v-layout column align-center>
                


                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                
                <!-- <v-text-field
                    v-model="credentials.email"
                    :rules="emailRules"
                    label="Email"
                    required
                    color="blue"
                    class="mb-2"
                ></v-text-field> -->
                <v-text-field
                    v-model="credentials.user"
                    label="Rut"
                    required
                    color="blue"
                    class="mb-2"
                ></v-text-field>

                <v-text-field
                v-model="credentials.password"
                    :rules="passwordRules"
                    label="Password"
                    required
                    color="blue"
                    class="mb-2"
                    type="password"
                    v-on:keyup.enter="openSession">
                    
                </v-text-field>

                <v-btn
                    color="error"
                    class="mr-4"
                    @click="reset"
                >
                    Limpiar
                </v-btn>

                <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="openSession"
                >
                    Ingresar
                </v-btn>

                
                </v-form>
            </v-layout>
             </v-card-text>
            
            </v-card>
        </v-container>
        
        
    </div>
</template>
<script>
import {mapActions,mapState,mapMutations} from 'vuex'
// import axios from 'axios'
export default {
    data:()=>({
        valid: false,
        lazy:false,
        credentials:{
            user:'',
            password:''
        },
        emailRules: [
            v => !!v || 'El Email es Obligatorio',
            v => /.+@.+\..+/.test(v) || 'Ingrese un Email Válido',
        ],
        passwordRules: [
            v => !!v || 'El Password es Obligatorio'
        ]
    }),
    mounted() {
        // this.detectarIP();
    },
    methods:{
        async openSession (not_validate) {
            if (this.$refs.form.validate() || not_validate) {
                // console.log('enviar peticion');
                //this.mostrarLoading('Autenticando...')
            this.mostrarLoading({titulo:'Autenticando...',color:'green'})

                await this.axios.post(this.base_url+'login',{
                    user:this.credentials.user,
                    password:this.credentials.password
                }).then((response)=>{
                    // console.log('respuesta logueo',response.data);
                    if(response.data.access_token == ""){
                        //this.mostrarLoading('Credenciales Incorrectas')
            this.mostrarLoading({titulo:'Credenciales Incorrectas',color:'green'})

                    }else{
                        // console.log('siiiiii');
                        this.iniciarSession(response.data)
                        this.ocultarLoading()
                    }
                }).catch((error)=>{
                    console.log('error',error)
                    this.ocultarLoading()
                })
                //this.login(this.credentials)
            }
        },
        // detectarIP(){
        //     let url_actual = window.location.href
        //     if(url_actual.includes('localhost') || url_actual.includes('192.168.1.164') || url_actual.includes('192.168.0.143')){
        //         console.log(process.env.VUE_APP_BY_PASS_USER);
        //         this.credentials = {
        //             user: process.env.VUE_APP_BY_PASS_USER,
        //             password: process.env.VUE_APP_BY_PASS_PASSWORD
        //         };
        //         // this.openSession(true);
        //     }
        // },
        reset () {
            this.$refs.form.reset()
        },

        ...mapActions(['iniciarSession']),
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
}
</script>
